Librarian.Modules.AskMarketing = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-askmarketing-",
        email: null,
        label: null,
        header: null, 
        message: null,
        subject: "Ask Marketing Message",
        inputHeight: null,
        id: null,
        onClick: null,
        onPreDestroy: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        var self = this;
        this.options.onClick = function () {
            if (self.options.inputHeight) {
                this.inputWindow = new Librarian.InputWindow({
                    title: self.options.header,
                    height: self.options.inputHeight,
                    message: self.options.message,
                    buttonLabel: "OK",
                    onSubmit: function (value) {
                        // Replace new lines with line breaks to keep formatting
                        value = value.replaceAll("\r\n", "<br/>")
                                    .replaceAll("\r", "<br/>")
                                    .replaceAll("\n", "<br/>");

                        var eventInfo = new Librarian.Events.Event();
                        eventInfo.name = self.options.subject;
                        eventInfo.messagebody = value;
                        eventInfo.exectime = new Date();

                        var emails = self.options.email.split(';');
                        for (var i = 0; i < emails.length; i++) {
                            var recipientInfo = new Librarian.Contacts.Contact();
                            recipientInfo.email = emails[i];
                            eventInfo.addRecipient(recipientInfo);
                        }

                        Librarian.Events.sendEvent(eventInfo,
                        // Success
                            function () {
                                Librarian.Utils.notification(Librarian.Lang.getString("resource_email_sent"));
                            }.bind(this),
                        // Failure
                            function () {
                                Librarian.Utils.error(Librarian.Lang.getString("resource_email_failed"));
                            });
                    }
                }).show();
            } else {
                this.inputWindow = new Librarian.InputWindow({
                    title: self.options.header,
                    message: self.options.message,
                    buttonLabel: "OK",
                    onSubmit: function (value) {
                        // Replace new lines with line breaks to keep formatting
                        value = value.replaceAll("\r\n", "<br/>")
                                    .replaceAll("\r", "<br/>")
                                    .replaceAll("\n", "<br/>");

                        var eventInfo = new Librarian.Events.Event();
                        eventInfo.name = self.options.subject;
                        eventInfo.messagebody = value;
                        eventInfo.exectime = new Date();

                        var emails = self.options.email.split(';');
                        for (var i = 0; i < emails.length; i++) {
                            var recipientInfo = new Librarian.Contacts.Contact();
                            recipientInfo.email = emails[i];
                            eventInfo.addRecipient(recipientInfo);
                        }

                        Librarian.Events.sendEvent(eventInfo,
                        // Success
                            function () {
                                Librarian.Utils.notification(Librarian.Lang.getString("resource_email_sent"));
                            }.bind(this),
                        // Failure
                            function () {
                                Librarian.Utils.error(Librarian.Lang.getString("resource_email_failed"));
                            });
                    }
                }).show();
            }
        };

        wrapperEl.addOnClick(this.options.onClick);

        this.options.onPreDestroy = function() {
            if (this.inputWindow) {
                this.inputWindow.close();
                this.inputWindow = null;
            }
        };

        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();
        this.wrapperEl.addClass("nav-wrapper");
      
        // add label
        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }
});